/**
 * Play/pause for autoplay videos. Loaded as type="module".
 */

function label(isPlaying) {
  const a11y = window.theme?.strings?.accessibility || {}
  return isPlaying
    ? a11y.pause_video || a11y.pause || 'Pause video'
    : a11y.play_video || 'Play video'
}

function setPlaying(button, isPlaying) {
  button.dataset.status = isPlaying ? 'play' : 'pause'
  const text = label(isPlaying)
  button.setAttribute('aria-label', text)
  const srOnly = button.querySelector('.sr-only')
  if (srOnly) srOnly.textContent = text
}

function videosIn(wrapper) {
  return [...wrapper.getElementsByTagName('video')]
}

function controllableVideosIn(wrapper) {
  const videos = videosIn(wrapper)
  const visibleVideos = videos.filter((video) => video.getClientRects().length > 0)
  return visibleVideos.length ? visibleVideos : videos
}

function onToggle(event) {
  const button = event.target.closest('[data-video-pause]')
  if (!button) return

  const wrapper = button.closest('[data-video-wrapper]')
  if (!wrapper) return

  event.preventDefault()
  event.stopPropagation()

  const videos = controllableVideosIn(wrapper)
  if (!videos.length) return

  const playing = videos.some((video) => !video.paused)

  for (const video of videos) {
    if (playing) {
      video.dataset.userPaused = '1'
      video.pause()
    } else {
      delete video.dataset.userPaused
      video.dataset.userInitiated = '1'
      video.loadVideo?.()
      video.play()?.catch(() => setPlaying(button, false))
    }
  }

  setPlaying(button, !playing)
}

function pauseForUserPreferences(root = document) {
  const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches
  const saveData = navigator.connection?.saveData === true
  if (!reduceMotion && !saveData) return

  for (const wrapper of root.querySelectorAll('[data-video-wrapper]')) {
    const button = wrapper.querySelector('[data-video-pause]')
    const videos = videosIn(wrapper)
    if (!button || !videos.length) continue
    for (const video of videos) {
      video.dataset.userPaused = '1'
      video.pause()
    }
    setPlaying(button, false)
  }
}

document.addEventListener('click', onToggle, true)
document.addEventListener(
  'touchstart',
  (event) => {
    if (event.target.closest('[data-video-pause]')) event.stopPropagation()
  },
  { capture: true, passive: true }
)

pauseForUserPreferences()
document.addEventListener('shopify:section:load', (event) => {
  pauseForUserPreferences(event.target)
})
